export default "__VITE_ASSET__CCqTks3K__"